import { prompt } from '@sloyd/ui';
import { delay, fork, takeLatest } from 'saga-ts';
import { invokeEvent, l } from 'shared-base';
import { forms } from '../_definitions/forms';

export const saga = {
  id: 'sloyd.settings',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['SETTINGS'],
  },
};

type Verb =
  | 'show' //
  | 'save'
  | 'bootstrap';

type Action = {
  type: 'SETTINGS';
  verb: Verb;
  id: string;
  payload: Json;
};

const map: Record<Verb, any> = {
  show: showSettings,
  save: saveSettings,
  bootstrap: bootstrapSettings,
};

export function* showSettings(action: Action) {
  try {
    const { value, didCancel } = yield prompt.form({
      config: forms.settings,
      data: {},
      allOptions: {},
    });
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* saveSettings(action: Action) {}

export function* bootstrapSettings(action: Action) {}

export function* settings(action: any) {
  const { verb } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.settings ${verb}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeLatest('SETTINGS', settings);
  // yield put({ type: 'SETTINGS', verb: 'show' });
}
